import { IOffer } from '../../../types/offer';

export function isRepresentative(offer: IOffer): boolean {
  return Boolean(offer.businessShoppingCenter?.fromRepresentative);
}
